<mat-spinner [diameter]="diameter" [mode]="mode" />
